import {
  Button,
  CircularProgress,
  Paper,
  Switch,
  Tab,
  Tabs,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Dropdown from "../../../../components/inputs/dropDown";
import TextInput from "../../../../components/inputs/textInput";
import { API } from "../../../../scripts/api";
import axiosInstance from "../../../../scripts/axiosInspector";

const CreateUser = ({
  data,
  setData,
  handleSumbit,
  loadingSubmit,
  isModal = false,
}) => {
  const [value, setValue] = useState(0);
  const dispatch = useDispatch();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const { id } = useParams();
  const [error, setError] = useState({});
  const location = useLocation();
  const [buyerType, setBuyerType] = useState([]);
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  useEffect(() => {
    axiosInstance
      .get(API.public.buyerType, {
        headers: {
          Authorization: `Bearer ${userInfo?.token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "Accept-Language": "fa-IR",
          chHostName: process.env.REACT_APP_CHHOSTNAME,
        },
      })
      .then((res) => {
        setBuyerType(res?.data?.data);
      })
      .catch((err) => {
        /*       if (err.response.status === 401 || err.response.status === 403) {
          dispatch(handleLogOut());
        } */
      });
  }, []);
  const navigate = useNavigate();
  return (
    <>
      <Paper
        /*    sx={{}} */

        elevation={isModal ? 0 : 1}
        className={`mx-3 my-5 ${
          isModal ? "" : "border"
        }  py-3 px-3 relative z-40`}
      >
        <Tabs
          className="primary"
          sx={{
            flexGrow: 1,
            height: "3.07rem",
            minHeight: "3.07rem !important",
            ".MuiTab-root": {
              minHeight: "3.07rem !important",
            },

            ".MuiTabs-flexContainer": {
              justifyContent: { xs: "center", md: "start" },
            },
          }}
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label=" اطلاعات پایه  " {...a11yProps(0)} />
          <Tab className="middle" label=" اطلاعات تکمیلی " {...a11yProps(1)} />
        </Tabs>

        <TabPanel dir={"rtl"} value={value} index={0}>
          <div className="flex flex-col mt-7 gap-4 lg:grid grid-cols-4">
            <TextInput
              label=" عنوان"
              onChange={(e) => {
                setData({ ...data, chName: e });
                if (!e) {
                  setError({ ...error, chName: true });
                } else {
                  setError({ ...error, chName: false });
                }
              }}
              value={data?.chName || ""}
              err={error.chName}
            />
            <Dropdown
              label="نوع"
              onChange={(e) => {
                setData({ ...data, chBuyerTypeCode: e });
                if (!e) {
                  setError({ ...error, chBuyerTypeCode: true });
                } else {
                  setError({ ...error, chBuyerTypeCode: false });
                }
              }}
              value={data?.chBuyerTypeCode}
              data={buyerType}
              feild={"chCode"}
              err={error.chBuyerTypeCode}
            />
            <TextInput
              label={`  ${
                data?.chBuyerTypeCode === "Legal" ? "شناسه" : "کد"
              } ملی`}
              onChange={(e) => {
                if (data?.chBuyerTypeCode === "Legal") {
                  if (e.length < 12) {
                    setData({ ...data, chNationalID: e });
                    if (!e && data?.chBuyerTypeCode !== "Consumer") {
                      setError({ ...error, chNationalID: true });
                    } else if (data?.chBuyerTypeCode !== "Consumer") {
                      setError({
                        ...error,
                        chNationalID: e.length <= 10 || e.length > 12,
                      });
                    }
                  }
                } else {
                  if (e.length < 11) {
                    setData({ ...data, chNationalID: e });
                    if (!e && data?.chBuyerTypeCode !== "Consumer") {
                      setError({ ...error, chNationalID: true });
                    } else if (data?.chBuyerTypeCode !== "Consumer") {
                      setError({
                        ...error,
                        chNationalID: e.length <= 9 || e.length > 11,
                      });
                    }
                  }
                }
              }}
              value={data?.chNationalID || ""}
              err={error.chNationalID}
              number
              noSepreate
              allowZero={data?.chBuyerTypeCode === "Consumer"}
            />
            {isModal && (
              <TextInput
                label=" تلفن همراه"
                onChange={(e) => {
                  if (e.length < 12) {
                    setData({ ...data, chMobile: e });
                  }
                }}
                number
                noSepreate
                value={data?.chMobile || ""}
              />
            )}
            <TextInput
              label=" شناسه"
              onChange={(e) => {
                setData({ ...data, chSaleSoftID: e });
                if (!e) {
                  setError({ ...error, chSaleSoftID: true });
                } else {
                  setError({ ...error, chSaleSoftID: false });
                }
              }}
              value={data?.chSaleSoftID || ""}
              err={error.chSaleSoftID}
            />{" "}
            <TextInput
              label=" کدپستی"
              onChange={(e) => {
                setData({ ...data, chPostCode: e });
              }}
              number
              noSepreate
              err={error.chPostCode}
            />
          </div>
        </TabPanel>
        <TabPanel dir={"rtl"} value={value} index={1}>
          <div className="flex flex-col gap-4 mt-7 lg:grid grid-cols-4 ">
            <TextInput
              label=" شماره ثبت"
              onChange={(e) => {
                setData({ ...data, chRegisterationNumber: e });
              }}
              value={data?.chRegisterationNumber || ""}
            />
            <TextInput
              label=" شماره اقتصادی"
              onChange={(e) => {
                setData({ ...data, chEconomicCode: e });
              }}
              value={data?.chEconomicCode || ""}
            />

            <TextInput
              label=" کد شعبه"
              onChange={(e) => {
                setData({ ...data, chBranchCode: e });
              }}
              value={data?.chBranchCode || ""}
            />
            <TextInput
              label=" شماره گذرنامه"
              onChange={(e) => {
                setData({ ...data, chPassportNumber: e });
              }}
              number
              noSepreate
              allowZero
              value={data?.chPassportNumber || ""}
            />
            <TextInput
              label=" مدیرعامل"
              onChange={(e) => {
                setData({ ...data, chCEOFullName: e });
              }}
              value={data?.chCEOFullName || ""}
            />
            {!isModal && (
              <TextInput
                label=" تلفن همراه"
                onChange={(e) => {
                  if (e.length < 12) {
                    setData({ ...data, chMobile: e });
                  }
                }}
                number
                allowZero
                noSepreate
                value={data?.chMobile || ""}
              />
            )}

            <TextInput
              label="  تلفن ثابت"
              onChange={(e) => {
                setData({ ...data, chTel: e });
              }}
              number
              allowZero
              noSepreate
              value={data?.chTel || ""}
            />
            <div className="col-span-4">
              {" "}
              <TextInput
                label=" آدرس"
                onChange={(e) => {
                  setData({ ...data, chAddress: e });
                }}
                rows={2}
                value={data?.chAddress || ""}
              />
            </div>
            <div className="col-span-4">
              {" "}
              <TextInput
                label=" توضیحات"
                onChange={(e) => {
                  setData({ ...data, chComment: e });
                }}
                value={data?.chComment || ""}
                rows={2}
              />
            </div>

            <div className="flex gap-3 items-center col-span-2">
              <span>غیر فعال :‌</span>
              <Switch
                onChange={(e) =>
                  setData({ ...data, btDisabled: !data?.btDisabled })
                }
                checked={data?.btDisabled}
              />
            </div>
            <div className="col-span-2">
              {" "}
              <TextInput
                label="توضیحات غیرفعال"
                onChange={(e) => setData({ ...data, chDisabledComment: e })}
                value={data?.chDisabledComment || ""}
                rows={2}
              />
            </div>
          </div>
        </TabPanel>
        <div className="flex w-full loginButton my-7 items-center justify-between">
          <Button
            sx={{ width: "135px" }}
            onClick={handleSumbit}
            variant="contained"
            disabled={
              loadingSubmit ||
              !data?.chName ||
              !data?.chBuyerTypeCode ||
              /*   (!data?.chNationalID && !isModal) || */
              !data?.chSaleSoftID ||
              (data?.chBuyerTypeCode === "Real" ? !data?.chPostCode : false) ||
              (data?.chBuyerTypeCode !== "Consumer"
                ? !data?.chNationalID
                : false) ||
              (data?.chBuyerTypeCode === "Consumer" && isModal
                ? !data?.chMobile
                : false)
            }
          >
            {loadingSubmit ? (
              <>
                <CircularProgress size={20} />
              </>
            ) : (
              <>ثبت</>
            )}
          </Button>
          <Button
            sx={{ width: "135px" }}
            onClick={() =>
              navigate(!isModal ? "/sell/customer" : location.pathname)
            }
            variant="outlined"
          >
            بازگشت
          </Button>
        </div>
      </Paper>
    </>
  );
};

export default CreateUser;
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <>
          <>{children}</>
        </>
      )}
    </div>
  );
}
